import { render, staticRenderFns } from "./SingleCardAd.vue?vue&type=template&id=ea972eb4&scoped=true"
import script from "./SingleCardAd.vue?vue&type=script&lang=js"
export * from "./SingleCardAd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea972eb4",
  null
  
)

export default component.exports